import { Flame } from "lucide-react";
import { Ladybug } from "@/components/site/Ladybug";

const SHOP_CANDLES = "https://thehealersmarket.shop/Prayer-&-Alignment-Candles-c188345764";

const CANDLES = [
  {
    key: "owl",
    name: "The Owl Candle",
    img: "/img/candle-owl.jpg",
    pos: "object-[50%_35%]",
    text: "The owl sees what hides in the dark. Light this candle when you need clarity, discernment, and the courage to see the truth in your life and walk in it. A keeper of wisdom for the long nights ahead.",
  },
  {
    key: "rain",
    name: "The Rain Callers",
    img: "/img/candle-rain.jpg",
    pos: "object-center",
    text: "Rain does not ask permission to bless the land. Light the Rain Callers to call down renewal, wash away what is stagnant, and open the way for growth, abundance, and new life to pour in.",
  },
];

export const Candles = () => (
  <section data-testid="candles-section" className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
    <div className="grid lg:grid-cols-12 gap-12 items-start">
      <div className="lg:col-span-4">
        <span className="eyebrow">Ambassador Exchange</span>
        <h2 className="font-serif-h text-4xl sm:text-5xl text-[#577731] mt-4 leading-tight">The Candles of the Season <Ladybug size={22} rotate={110} /></h2>
        <p className="mt-6 text-[#232b1b]/75 leading-relaxed">
          Every season carries its own medicine. These two were poured for this one, and for this season only, Ambassadors receive them at a sacred exchange.
        </p>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-6">
        {CANDLES.map(({ key, name, img, pos, text }) => (
          <article key={key} data-testid={`candle-${key}`} className="card-soft overflow-hidden hover:border-[#b6689a] hover:-translate-y-1 flex flex-col">
            <a href={SHOP_CANDLES} target="_blank" rel="noreferrer" data-testid={`candle-img-link-${key}`} className="block overflow-hidden aspect-[4/5] bg-[#dacac1]/40">
              <img src={img} alt={name} data-testid={`candle-img-${key}`} className={`h-full w-full object-cover ${pos} transition-transform duration-700 hover:scale-105`} />
            </a>
            <div className="p-8">
            <h3 className="font-serif-h text-3xl text-[#232b1b]"><a href={SHOP_CANDLES} target="_blank" rel="noreferrer" className="hover:text-[#b6689a] transition-colors">{name}</a></h3>
            <p className="mt-4 text-sm leading-relaxed text-[#232b1b]/75">{text}</p>
            <p className="mt-6 flex items-baseline gap-3">
              <span className="line-through text-[#232b1b]/45">$44</span>
              <span className="font-serif-h text-3xl text-[#577731]">$34</span>
              <span className="text-xs uppercase tracking-widest text-[#b6689a]">this season only</span>
            </p>
            <a href={SHOP_CANDLES} target="_blank" rel="noreferrer" data-testid={`candle-shop-btn-${key}`} className="btn btn-olive mt-6 !py-2.5 !px-6 text-sm">Shop This Candle</a>
            </div>
          </article>
        ))}
        <div className="sm:col-span-2 flex flex-col sm:flex-row sm:items-center justify-between gap-6 rounded-3xl bg-[#b1cc90]/35 p-8">
          <p className="flex items-center gap-3 text-sm text-[#232b1b]/85">
            <Flame size={18} className="text-[#b6689a] shrink-0" />
            $10 off each candle, for Ambassadors, all season long. When the season turns, so does the price.
          </p>
          <a href={SHOP_CANDLES} target="_blank" rel="noreferrer" data-testid="claim-candles-btn" className="btn btn-mauve shrink-0">
            Claim Your Candles at TheHealersMarket.shop
          </a>
        </div>
      </div>
    </div>
    <Gamechanger />
  </section>
);

const AREAS = ["Your health", "Your relationships", "Your finances", "Your emotional body"];

const Gamechanger = () => (
  <div data-testid="gamechanger-section" className="relative mt-20 rounded-[2rem] bg-[#232b1b] text-[#faf7f2] p-8 sm:p-14 grid lg:grid-cols-12 gap-10 overflow-hidden">
    <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-[#b6689a]/30 blur-3xl breathe" />
    <Ladybug spot="br" size={24} rotate={-140} />
    <div className="relative lg:col-span-6">
      <span className="text-[11px] uppercase tracking-[0.3em] text-[#b1cc90]">The Offering You Cannot Resist This Season</span>
      <h2 className="font-serif-h text-5xl sm:text-6xl mt-4">The Gamechanger</h2>
      <p className="font-serif-h italic text-2xl text-[#e2b6d2] mt-4">Align right. Realign your life with medicine and ritual.</p>
    </div>
    <div className="relative lg:col-span-6 space-y-5 text-[#faf7f2]/85 leading-relaxed">
      <p>Wherever you have been wounded, wherever you have been struggling, The Gamechanger meets you there. This sacred calendar guides you, day by day, through medicine and ritual to tend every area of your life:</p>
      <ul className="grid grid-cols-2 gap-3">
        {AREAS.map((a) => <li key={a} className="rounded-2xl border border-white/15 px-4 py-3 text-sm">{a}</li>)}
      </ul>
      <p>It is all here. Stop circling the same lessons. Jump to a better timeline and step into your best life.</p>
      <a href="https://thehealersmarket.shop" target="_blank" rel="noreferrer" data-testid="gamechanger-btn" className="btn btn-mauve">Get The Gamechanger Now at TheHealersMarket.shop</a>
    </div>
  </div>
);
